import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CardApplicationDirectDepositSwitcher from '@perpay-web/fintech/components/screens/CardApplicationDirectDepositSummarySwitcher/CardApplicationDirectDepositSwitcher';
import {
    fetchJobsDataModule,
    getCompanyName,
} from '@perpay-web/fintech/dataModules/fetchJobs';

const CardApplicationDirectDepositSwitcherContainer = ({
    applicationUuid = null,
}) => {
    const dispatch = useDispatch();
    const onMount = useCallback(() => {
        dispatch(fetchJobsDataModule.dataRequest());
    }, [dispatch]);

    const companyName = useSelector(getCompanyName);

    return (
        <CardApplicationDirectDepositSwitcher
            applicationUuid={applicationUuid}
            onMount={onMount}
            companyName={companyName}
        />
    );
};

export default CardApplicationDirectDepositSwitcherContainer;
